import { Input } from '@fnacdarty/back-office-ui';
import styled from 'styled-components';

// eslint-disable-next-line import/prefer-default-export
export const StyledFilterContainer = styled.div`
	display: flex;
	flex-direction: column;
	align-items: center;
	justify-content: flex-start;
	position: relative;
	top: 0px;
	margin: 0 40px 0 5px;
	background-color: ${({ theme }) => theme.colors.primaryLight};
	color: #ffffff;
	border: 1px solid transparent;
	border-radius: 5px;
	padding: 10px;
	height: 500px;
`;

export const StyledHeader = styled.div`
	margin-bottom: 10px;
	display: flex;
	flex-direction: column;
	width: 100%;
	justify-content: center;
	align-items: flex-start;
	& > hr {
		border: 1px solid #ffffff;
	}
`;

export const StyledDropdownContainer = styled.div`
	display: flex;
	width: 100%;
	margin-bottom: 10px;
`;

export const StyledListContainer = styled.div`
	display: flex;
	flex-direction: column;
	width: 100%;
	justify-content: flex-start;
	align-items: center;
	height: 100%;
	color: ${({ theme }) => theme.colors.primary};
	overflow: auto;
	height: 100%;
	max-height: 200px;
	margin: 5px 0;
	&::-webkit-scrollbar {
		width: 10px;
	}
	&::-webkit-scrollbar-track {
		background: #f1f1f1;
	}
	&::-webkit-scrollbar-thumb {
		background-color: ${({ theme }) => theme.colors.primary};
		border-radius: 10px;
		border: 2px solid #f1f1f1;
	}
	&::-webkit-scrollbar-thumb:hover {
		background-color: ${({ theme }) => theme.colors.primaryLight};
	}
`;

export const StyledInput = styled(Input)`
	height: 40px;
	margin-bottom: 5px;
`;

export const StyledList = styled.ul`
	display: flex;
	flex-direction: column;
	width: 100%;
	justify-content: flex-start;
	align-items: center;
	list-style: none;
	margin: 0;
	padding: 10px;
	background-color: ${({ theme }) => theme.colors.background};
	color: ${({ theme }) => theme.colors.primary};
	border: 1px solid;
	border-radius: 10px;
`;

export const StyledItem = styled.li`
	display: flex;
	flex-direction: row;
	width: 100%;
	justify-content: space-between;
	align-items: center;
	margin: 0;
	padding: 5px;
	height: 30px;
	cursor: pointer;
	background-color: ${({ $selected, theme }) =>
		$selected ? theme.colors.secondary : theme.colors.background};
	color: ${({ $selected, theme }) =>
		$selected ? theme.colors.background : theme.colors.text};
	&:hover {
		background-color: ${({ theme }) => theme.colors.secondary};
		color: ${({ theme }) => theme.colors.background};
	}
	& > span {
		overflow: hidden;
		word-wrap: break-word;
		text-overflow: ellipsis;
		white-space: nowrap;
	}
`;
export const StyledDropdown = styled.div`
	display: flex;
	justify-content: space-between;
	margin: 7px;
`;
export const StyledFilterList = styled.div`
	margin-bottom: 10px;
	margin-top: 5px;
	color: ${({ theme }) => theme.colors.primary};
`;
